import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EditorPanel } from "./components/editor-panel/EditorPanel";
import { HistoryPanel } from "./components/history/HistoryPanel";
import { PanelToggle } from "./components/layout/PanelToggle";
import { AppNav } from "./components/navigation/AppNav";
import { ScheduleArtPreviewPanel } from "./components/schedule/ScheduleArtPreviewPanel";
import { ScheduleInputPanel } from "./components/schedule/ScheduleInputPanel";
import "./index.css";
import { useHistoryShortcuts } from "./lib/schedule-history/use-history-shortcuts";
import { cn } from "./lib/utils";
import { useMetadataBuilderStore } from "./stores/metadata-builder-store";

export function App() {
  useHistoryShortcuts();
  const { i18n } = useTranslation();
  const [inputOpen, setInputOpen] = useState(true);
  const [editorOpen, setEditorOpen] = useState(true);
  const builderActive = useMetadataBuilderStore(state => state.active);
  const showInput = inputOpen && !builderActive;
  const showEditor = editorOpen || builderActive;
  const fontFamily = i18n.resolvedLanguage === "zh-TW" ? "'Chiron GoRound TC', sans-serif" : "Inter, sans-serif";
  return (
    <div className="grid h-svh grid-rows-[auto_minmax(0,1fr)] overflow-hidden bg-neutral-50 text-xs text-neutral-900"
      style={{ fontFamily }}>
      <AppNav />
      <main className="min-h-0 overflow-hidden p-4 min-[480px]:p-6">
        <div className={cn(
          "grid h-full min-h-0 grid-cols-1 grid-rows-[minmax(0,1fr)] items-start gap-6",
          showInput && showEditor && "grid-cols-[minmax(440px,500px)_minmax(0,1fr)_500px]",
          showInput && !showEditor && "grid-cols-[minmax(440px,500px)_minmax(0,1fr)]",
          !showInput && showEditor && "grid-cols-[minmax(0,1fr)_500px]",
        )}>
          <div hidden={!showInput} id="schedule-input-panel" className="h-full min-h-0 min-w-0 overflow-hidden">
            <ScheduleInputPanel />
          </div>
          <div className="relative h-full min-h-0 min-w-0">
            {!builderActive && <PanelToggle side="left" open={inputOpen} onToggle={() => setInputOpen(open => !open)} />}
            <ScheduleArtPreviewPanel />
            {!builderActive && <PanelToggle side="right" open={editorOpen} onToggle={() => setEditorOpen(open => !open)} />}
          </div>
          <div hidden={!showEditor} id="editor-panel" className="h-full min-h-0 min-w-0 overflow-hidden">
            <EditorPanel />
          </div>
        </div>
      </main>
      <HistoryPanel />
    </div>
  );
}

export default App;
